export const SidebarDataAlu = [
  {
    title: 'Dashboard',
    path: '/',
    cName: 'nav-text'
  },
  {
    title: 'Personal Profile',
    path: '/personal_profile',
    cName: 'nav-text'
  },
  {
    title: 'Alumni Directory',
    path: '/alumni_directory',
    cName: 'nav-text'
  },
  {
    title: 'Events',
    path: '/events',
    cName: 'nav-text'
  },
  {
    title: 'Career Opportunity',
    path: '/career_opportunity',
    cName: 'nav-text'
  },
  {
    title: 'Further Education',
    path: '/further_education',
    cName: 'nav-text'
  }

];

